<h5>Sign up and get started instantly</h5>
<h2>Create a team for yourself and your team mates.</h2>
<mat-vertical-stepper [linear]="true" #stepper style="background-color: transparent" (selectionChange)="onStepperChanged($event)">

<!--    <button mat-button>Continue with Google</button>-->
<!--    <p>or</p>-->


  <mat-step [stepControl]="teamFormGroup" [editable]="editable">
    <form [formGroup]="teamFormGroup">
      <ng-template matStepLabel>Enter your team's name </ng-template>
      <mat-hint>A name for the group of people that will be using KaDeck Web. <mat-icon class="web-tooltip" aria-hidden="false" matTooltip="A good team name usually includes your project or department: ACME ProjectX,  ACME Data-Lake Team" aria-label="Tip">help</mat-icon></mat-hint>
      <mat-form-field class="definput" hintLabel="Minimum 5 characters">
        <mat-label>Team name</mat-label>
        <input matInput placeholder="MyCompany ProjectX, Superheroes..." formControlName="teamname" required>
      </mat-form-field>
      <div class="stepper-buttons">
        <button mat-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="personalInfoFormGroup" [editable]="editable">

  <form [formGroup]="personalInfoFormGroup">
      <ng-template matStepLabel>Enter your data</ng-template>
    <mat-hint>We need your contact information to send you the login credentials.</mat-hint>
      <mat-form-field class="definput">
        <mat-label>Full name</mat-label>
        <input matInput formControlName="name" placeholder="Your full name" required>
      </mat-form-field>
      <mat-form-field class="definput">
        <mat-label>Company</mat-label>
        <input matInput formControlName="company" placeholder="Your company name" required>
      </mat-form-field>
      <mat-form-field class="definput">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone" placeholder="">
      </mat-form-field>
      <mat-form-field class="definput">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Email address" required>
      </mat-form-field>

    <mat-checkbox style="margin-top: 20px; display: inline-block; font-weight: 500;" formControlName="accepteula"><span class="checkboxlabel">I acknowledge that I have read and agree to the <a href="https://www.xeotek.com/kadeck/eula/" target="_blank">End User License Agreement</a> and <a href="https://www.xeotek.com/privacy-policy/" target="_blank">Privacy Policy</a>. *</span></mat-checkbox>
    <mat-checkbox style="margin: 20px 0; display: inline-block;" formControlName="newsletter"><span class="checkboxlabel">I want to receive How-To's, events and promotions from Xeotek via mail.</span></mat-checkbox>
    <div class="stepper-buttons">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button color="primary" matStepperNext>Sign up</button>
      </div>
    </form>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Run KaDeck Web</ng-template>
    <div class="donebox">
      <ng-container [ngSwitch]="status">

        <mat-spinner id="spinner" [diameter]="50" *ngSwitchCase="'loading'"></mat-spinner>
        <div class="circleicon"*ngSwitchCase="'success'">
          <mat-icon aria-hidden="false" aria-label="Success"  color="primary" >done</mat-icon>
        </div>

        <div class="circleicon error" *ngSwitchCase="'failure'">
          <mat-icon aria-hidden="false" aria-label="Failure"  color="warn" >error</mat-icon>
        </div>

      </ng-container>

      <!-- Highlight Card -->
      <div class="card highlight-card card-small" style="margin-bottom: 50px">
        {{ statusmessage }}
      </div>
      <p *ngIf="status==='failure'">Something is wrong, please <a target="_blank" href="https://support.xeotek.com/hc/en-us/requests/new">contact us</a>.</p>
    </div>

  </mat-step>
</mat-vertical-stepper>
